<div
  class="conta_iner no_radius_input conta_iner get_started_page onboarding_sc">
  <div class="card">
    <div class="logo text-center">
      <figure routerLink="/">
        <img [src]="assetsConst.logo" alt="logo" />
      </figure>
    </div>
    <form class="form-group w-full">
      <p-dropdown
        [options]="filteredLanguages"
        [(ngModel)]="selectedLang"
        [ngModelOptions]="{ standalone: true }"
        appendTo="body"
        placeholder="{{ 'chooseLanguage' | translate }}"
        optionLabel="name"
        (onChange)="lang_change($event)"
        optionValue="language_code" />
      <div class="btn_center">
        <p-button
          [raised]="true"
          severity="danger"
          type="submit"
          (click)="submit()"
          >{{ 'getStarted' | translate }}</p-button
        >
      </div>
    </form>
  </div>
</div>
